import React, { useEffect, useRef, useState } from "react";
import { Link } from "gatsby";
import FreeQuotesModal from "../FreeQuotesModal";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openFreeQuotesModal, setOpenFreeQuotesModal] = useState(false);

  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Function to handle click outside the header
    const handleClickOutside = event => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [headerRef]);

  return (
    <div ref={headerRef}>
      <nav
        className={`lg:py-2.5 py-5 fixed top-0 left-0 w-full bg-white z-10 lg:px-7 px-5 transition-shadow duration-300 ${
          scrolled ? "shadow-md" : ""
        }`}
      >
        <div className="flex justify-between items-center relative container max-w-7xl mx-auto">
          <div className="text-lg font-bold">
            <Link to="/" aria-label="logo">
              <svg
                width="88"
                height="40"
                viewBox="0 0 88 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M69.2645 0.00640038C69.407 0.00414839 69.5493 0.00206234 69.6917 0C70.2852 0.00301055 70.8785 0.00597369 71.472 0.00898424C72.4508 0.0524594 73.4165 0.194975 74.3751 0.383051C75.8122 0.665165 77.2053 1.08719 78.5655 1.62013C79.7001 2.06488 80.7226 2.69044 81.6865 3.40984C82.887 4.30589 83.9919 5.30049 84.9126 6.47721C86.198 8.12007 87.0617 9.95665 87.5797 11.9531C87.7622 12.6563 87.8935 13.3689 87.9948 14.0869C88.0072 14.1754 87.9965 14.267 87.9725 14.3619C87.9003 14.1397 87.8219 13.9193 87.7574 13.695C87.4823 12.7401 87.065 11.842 86.6025 10.963C86.1184 10.0428 85.5544 9.17357 84.8427 8.39993C84.3299 7.84265 83.73 7.38568 83.1112 6.95027C81.8257 6.04566 80.4589 5.28567 78.9692 4.74143C78.1487 4.44179 77.2956 4.28268 76.434 4.16229C75.5182 4.03444 74.5973 3.96534 73.6705 3.98063C72.2464 4.00396 70.8778 4.2953 69.5453 4.77056C67.3703 5.54636 65.321 6.5666 63.3687 7.77532C61.3191 9.04431 59.4049 10.4859 57.591 12.0566C56.6385 12.8815 55.7193 13.7399 54.8151 14.6145C53.4783 15.908 52.0886 17.148 50.7232 18.4125C49.4616 19.5804 48.2022 20.7511 46.9218 21.8994C45.9839 22.7402 45.0918 23.6257 44.1737 24.4858C41.8317 26.6795 39.4218 28.799 36.8929 30.7882C34.3699 32.7729 31.7552 34.6314 28.944 36.2157C27.1389 37.2332 25.272 38.1232 23.2825 38.7552C22.0661 39.1415 20.8227 39.4033 19.5498 39.5108C18.1355 39.6303 16.7172 39.6488 15.3022 39.5134C13.4106 39.3321 11.6033 38.8353 9.8691 38.0861C8.66032 37.5639 7.50862 36.9394 6.42956 36.1934C3.4632 34.1427 1.49467 31.4108 0.525138 27.9978C0.285732 27.155 0.117138 26.299 0 25.4329L0.0974493 25.4236C0.432652 26.5881 0.903522 27.6988 1.48706 28.7662C2.0764 29.8443 2.75871 30.8555 3.69301 31.6843C4.36458 32.28 5.10645 32.7877 5.87084 33.2633C7.07796 34.014 8.34745 34.6396 9.72449 35.0424C10.6474 35.3125 11.5937 35.4593 12.5519 35.5434C13.393 35.6171 14.2362 35.6479 15.0795 35.6078C16.3771 35.546 17.6393 35.3096 18.8641 34.8756C21.6581 33.886 24.2326 32.499 26.6626 30.8437C28.3343 29.7051 29.9061 28.4467 31.4191 27.1162C32.7654 25.9322 34.0205 24.6594 35.2846 23.3948C37.1063 21.5722 39.0164 19.8394 40.9501 18.13C42.2055 17.0203 43.4409 15.889 44.6866 14.7688C46.3338 13.2873 47.9681 11.7916 49.6835 10.3841C51.9275 8.54287 54.198 6.73211 56.6273 5.12403C59.0227 3.53865 61.5415 2.16888 64.2572 1.1638C65.5088 0.700557 66.7871 0.326514 68.1153 0.135546C68.4967 0.0808107 68.8813 0.0487851 69.2645 0.00640038Z"
                  fill="#FFA123"
                />
                <path
                  d="M8.60293 28.1321C8.15489 27.8427 7.76062 27.5561 7.37446 27.2589C5.50288 25.8189 3.92995 24.1242 2.74285 22.1028C1.72632 20.3717 1.06485 18.5195 0.731303 16.5525C0.506456 15.2269 0.449873 13.892 0.540372 12.5576C0.640473 11.0815 0.917932 9.62959 1.45432 8.23874C2.22813 6.23246 3.55653 4.64066 5.34455 3.40259C6.61355 2.52377 8.00929 1.89741 9.48362 1.42321C10.955 0.950013 12.4629 0.657397 14.0049 0.518959C14.9711 0.432009 15.9383 0.386756 16.9082 0.426367C18.205 0.479324 19.4738 0.702508 20.7233 1.03758C22.96 1.63753 25.0558 2.56113 27.0756 3.65861C29.5511 5.00361 31.8601 6.5864 34.0702 8.30912C36.2374 9.99852 38.2903 11.8116 40.238 13.737C40.5403 14.0359 40.8344 14.3422 41.1301 14.6474C41.2759 14.7978 41.2793 14.8052 41.1311 14.9623C40.8215 15.2905 40.5115 15.6185 40.1905 15.936C38.258 17.8484 36.2574 19.693 34.2561 21.5365C32.5484 23.11 30.8323 24.6747 29.1124 26.2358C27.0751 28.0849 24.8577 29.6951 22.3891 30.9636C21.0032 31.6757 19.5589 32.2449 18.025 32.5795C16.9509 32.8138 15.8667 32.9344 14.7648 32.819C14.7203 32.8143 14.6749 32.814 14.6308 32.8067C14.5249 32.7893 14.4195 32.7689 14.3119 32.7494C14.3214 32.6744 14.3871 32.6835 14.4297 32.6773C15.7661 32.4837 17.0137 32.0258 18.2265 31.4675C20.0016 30.6504 21.647 29.6237 23.2373 28.5098C25.4189 26.9819 27.4675 25.2967 29.4452 23.5283C31.5548 21.6418 33.577 19.67 35.5135 17.6153C35.5984 17.5251 35.6815 17.4333 35.764 17.341C35.7811 17.3219 35.7922 17.2976 35.8109 17.2678C35.7756 17.2295 35.7429 17.1884 35.7046 17.1528C33.0808 14.7054 30.3027 12.4456 27.2089 10.5725C25.2207 9.36874 23.1377 8.35822 20.8934 7.68418C19.2892 7.20247 17.6511 6.91777 15.9676 6.93226C14.5184 6.94466 13.1202 7.20823 11.7632 7.71735C9.5086 8.56336 7.71959 9.9914 6.27785 11.8436C5.39319 12.98 4.92166 14.2938 4.72213 15.703C4.48074 17.41 4.68804 19.0829 5.13277 20.7346C5.81459 23.2671 6.97126 25.5925 8.42259 27.7865C8.47602 27.8672 8.53145 27.9467 8.58406 28.0281C8.59233 28.0406 8.59035 28.0594 8.60293 28.1321Z"
                  fill="#00C6FF"
                />
                <path
                  d="M72.4989 39.9989C72.013 39.9993 71.5271 39.9997 71.0409 40C68.7007 39.8799 66.4818 39.2756 64.3312 38.4025C61.7172 37.3413 59.2998 35.9412 56.9873 34.362C54.2554 32.4964 51.7116 30.4096 49.302 28.1654C48.4717 27.3919 47.6602 26.6008 46.8773 25.7819C46.7224 25.6199 46.7183 25.6139 46.8757 25.4468C47.1787 25.1248 47.4822 24.8027 47.7966 24.4913C49.8728 22.4343 52.0221 20.4503 54.173 18.4682C55.8872 16.8884 57.5854 15.2911 59.3384 13.7531C61.7715 11.6182 64.4269 9.79661 67.4846 8.58558C68.6698 8.1162 69.8914 7.77195 71.1649 7.62593C71.987 7.53173 72.8109 7.51208 73.6491 7.67277C73.5947 7.72945 73.5351 7.73462 73.4815 7.74282C72.0285 7.96148 70.6801 8.47946 69.3726 9.10952C67.6378 9.94555 66.0255 10.9746 64.4658 12.0846C62.2236 13.6805 60.1211 15.4385 58.09 17.2798C56.237 18.9601 54.4559 20.7095 52.7361 22.5184C52.5837 22.6786 52.4333 22.8407 52.2847 23.0043C52.1537 23.1486 52.1514 23.1541 52.3029 23.2916C52.8941 23.8274 53.4808 24.3681 54.0818 24.8931C56.3581 26.881 58.7619 28.7042 61.3964 30.2271C63.1841 31.2605 65.0495 32.13 67.0405 32.7305C68.6446 33.2144 70.282 33.5013 71.9652 33.4864C73.4046 33.4737 74.7962 33.2179 76.1433 32.7064C77.6983 32.1159 79.0496 31.2423 80.2395 30.1079C81.001 29.3817 81.6954 28.6126 82.2017 27.6938C82.7777 26.6483 83.1043 25.531 83.224 24.3533C83.4072 22.5514 83.1244 20.8002 82.5998 19.0795C81.9004 16.786 80.8305 14.6591 79.5037 12.6503C79.4506 12.57 79.4048 12.4852 79.3555 12.4027L79.4031 12.365C79.8732 12.6397 80.2994 12.973 80.7238 13.3079C82.6268 14.8102 84.2047 16.5791 85.3661 18.687C86.2597 20.3087 86.8467 22.0305 87.1578 23.8453C87.3671 25.0658 87.4081 26.2933 87.3573 27.5252C87.339 27.9693 87.2854 28.4121 87.2101 28.8517C87.101 29.488 87.0368 30.1309 86.8843 30.7608C86.2506 33.3804 84.7995 35.4619 82.5502 37.0217C81.282 37.9008 79.8869 38.5267 78.4129 39.0004C76.9421 39.4733 75.4356 39.7705 73.8935 39.8995C73.4292 39.9385 72.9638 39.9662 72.4989 39.9989Z"
                  fill="#00C6FF"
                />
              </svg>

              {/* <img src={logo} alt="logo" className="sm:h-10 h-9 aspect-[2.1]" /> */}
            </Link>
          </div>
          <div className="flex items-center lg:hidden">
            <button
              aria-label="button"
              onClick={() => setIsOpen(!isOpen)}
              className=" outline-none focus:outline-none transition-all duration-300 ease-in-out"
            >
              {isOpen ? (
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                </svg>
              )}
            </button>
          </div>
          <div
            className={`lg:flex lg:items-center lg:static absolute  top-[60px] left-0 w-full lg:w-auto lg:px-0 px-3  lg:transition-none transition-all duration-300 linear transform bg-white lg:shadow-none shadow-lg ${
              isOpen
                ? "block sm:translate-y-0 -translate-y-[4px]"
                : "hidden -translate-y-5 lg:block lg:translate-y-0"
            }`}
          >
            <div className="lg:flex lg:items-center w-full lg:w-auto lg:pb-0 pb-3">
              <Link
                to="/"
                className="text-gray-900 font-medium block lg:inline-block lg:px-5 px-3 lg:py-5 py-2"
              >
                Home
              </Link>
              <Link
                to="/case-studies"
                className="text-gray-900 font-medium block lg:inline-block lg:px-5 px-3 lg:py-5 py-2"
              >
                Case Studies
              </Link>
              <Link
                to="/products"
                className="text-gray-900 font-medium block lg:inline-block lg:px-5 px-3 lg:py-5 py-2"
              >
                Solutions
              </Link>
              <div className="relative block lg:inline-block lg:px-5 px-0">
                <div className="group">
                  <p className="text-gray-900 font-medium block lg:inline-block lg:px-0 px-3 lg:py-5 py-2 cursor-pointer">
                    Services
                  </p>
                  <div className="lg:absolute relative top-full left-0 bg-white shadow-lg rounded-lg py-2 w-max overflow-hidden hidden group-hover:block">
                    <Link
                      to="/services/ai-automation-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      AI Automation Services
                    </Link>
                    <Link
                      to="/services/n8n-workflow-automation-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      n8n Workflow Automation
                    </Link>
                    <Link
                      to="/services/shopify-ai-automation-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      Shopify AI Automation
                    </Link>
                    <Link
                      to="/services/chatbot-development-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      ChatBot Development
                    </Link>
                    <Link
                      to="/services/generative-ai-development-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      Generative AI Development
                    </Link>
                    <Link
                      to="/services/laravel-development-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      Laravel Development
                    </Link>
                    <Link
                      to="/services/react-js-development-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      ReactJs Development
                    </Link>
                    <Link
                      to="/services/node-js-development-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      NodeJS Development
                    </Link>
                    <Link
                      to="/services/mobile-app-development-services"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      Mobile App Development
                    </Link>
                  </div>
                </div>
              </div>
              <div className="relative block lg:inline-block lg:px-5 px-0">
                <div className="group">
                  <p className="text-gray-900 font-medium block lg:inline-block lg:px-0 px-3 lg:py-5 py-2 cursor-pointer">
                    Company
                  </p>
                  <div className="lg:absolute relative top-full left-0 bg-white shadow-lg rounded-lg py-2 w-max overflow-hidden hidden group-hover:block">
                    <Link
                      to="/about-us"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      About Us
                    </Link>
                    <Link
                      to="/career"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      Career
                    </Link>
                    <Link
                      to="/contact-us"
                      className="block px-6 py-2 text-gray-700 font-medium hover:bg-gray-200"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
              <a
                href="/blog/"
                className="text-gray-900 font-medium block lg:inline-block lg:px-5 px-3 lg:py-5 py-2"
              >
                Blog
              </a>
              <div className="lg:pl-5 lg:pr-0 pl-3 pr-3  lg:py-0 py-2">
                <button
                  onClick={e => setOpenFreeQuotesModal(true)}
                  className="bg-gray-200 text-gray-900 font-medium py-2.5 px-6 rounded"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      {openFreeQuotesModal && <FreeQuotesModal onClose={() => setOpenFreeQuotesModal(false)} />}
    </div>
  );
};

export default Header;
